import KidoAPIInstance from "../../services/KidoConfigApi";

export const getListGameApi = async () => {
	const path = `api/games/list`;
	return await KidoAPIInstance.get(path);
};
